/* hejsmilla – kleine Theme-Skripte. Wird in layout/theme.liquid geladen (CUSTOM). */

// EU-Gewährleistungshinweis (snippets/hs-gewaehrleistung.liquid): Der Link öffnet die vollständige Mitteilung im Fenster.
// Ereignis-Delegation, weil der Mini-Warenkorb seinen Inhalt nachlädt (Skripte darin würden nicht ausgeführt).
// Ohne JavaScript oder ohne <dialog>-Unterstützung führt der Link auf /pages/gewaehrleistung.
document.addEventListener("click", (event) => {
  const opener = event.target.closest("[data-hs-ew-open]");
  if (opener) {
    const dialog = opener.parentNode.querySelector("dialog.hs-ew__dialog");
    if (!dialog || typeof dialog.showModal !== "function") return;
    event.preventDefault();
    if (!dialog.dataset.hsReady) {
      dialog.dataset.hsReady = "true";
      // Esc schließt nur das Fenster, nicht auch den Mini-Warenkorb: Das Fenster schließt schon bei keydown,
      // das folgende keyup landet auf dem Link im Warenkorb und würde ihn schließen. Dieses eine keyup abfangen.
      dialog.addEventListener("cancel", () =>
        document.addEventListener(
          "keyup",
          (keyEvent) => keyEvent.key === "Escape" && keyEvent.stopPropagation(),
          { capture: true, once: true },
        ),
      );
    }
    dialog.showModal();
    return;
  }
  const dialog = event.target.closest("dialog.hs-ew__dialog");
  if (
    dialog &&
    (event.target === dialog || event.target.closest("[data-hs-ew-close]"))
  )
    dialog.close();
});

// Cookie-Banner (Consentmo): Die App wertet Esc bei offenem Banner als Zustimmung zu allem (cookieconsent_status=dismiss).
// Solange keine Wahl gespeichert ist, Esc (keydown) vor Consentmo abfangen. Ablehnen, Akzeptieren und Einstellungen bleiben
// unverändert; keyup und das native Schließen von <dialog> laufen weiter (Mini-Warenkorb, Suche, EU-Fenster schließen per Esc).
window.addEventListener(
  "keydown",
  (event) => {
    if (
      (event.key === "Escape" || event.key === "Esc") &&
      !/(^|; )cookieconsent_status=/.test(document.cookie)
    )
      event.stopImmediatePropagation();
  },
  true,
);

// Mini-Warenkorb: Beim ersten Öffnen je Seitenaufruf lädt MiniCart.handleIntersection (assets/cart-drawer.js) den Inhalt nach
// und ersetzt dabei den fokussierten Schließen-Knopf. Danach Fokus und Fokusfalle neu in den Dialog setzen (CUSTOM-Methode in global.js).
document.addEventListener("cartdrawer:opened", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer && drawer.trapDialogFocus && drawer.querySelector("details[open]")) drawer.trapDialogFocus();
});
